export default __webpack_public_path__ + "static/media/Carousel-login.54db6a2d.gif";